<template>
  <div>
    <h1 class="text-h6 text-md-h4 mb-md-3" :class="fontWeightLightMd">
      {{ $t('site.title') }}
    </h1>
    <v-item-group
      :multiple="multiple"
      active-class="primary"
      v-model="selected"
    >
      <v-row>
        <v-col
          :key="`card-${i}`"
          cols="6"
          lg="3"
          v-for="(site, i) in getAllActiveSites"
        >
          <v-item :value="site.id" v-slot:default="{ active, toggle }">
            <v-card
              :color="active ? 'identity white--text' : ''"
              @click="toggle"
              min-width="150"
            >
              <v-scroll-y-transition>
                <div class="text-h2">
                  <v-img
                    class="align-self-stretch"
                    :src="managedImg(site.avatar)"
                    aspect-ratio="1.7"
                  >
                    <v-container class="fill-height pa-0" v-if="active">
                      <v-row align="end">
                        <v-row justify="center">
                          <div>
                            <v-icon dark>mdi-checkbox-marked-circle</v-icon>
                          </div>
                        </v-row>
                      </v-row>
                    </v-container>
                  </v-img>
                  <v-card-text primary-title class="button d-block text-center">
                    <span class="d-block text-caption dark">{{
                      site.city
                    }}</span>
                    <h1 class="d-block" :class="siteNameStyle">
                      {{ site.name }}
                    </h1>
                  </v-card-text>
                </div>
              </v-scroll-y-transition>
            </v-card>
          </v-item>
        </v-col>
      </v-row>
    </v-item-group>
  </div>
</template>

<script>
import { managedImg } from '@/micro/img'
import { siteNameText } from '@/micro/text'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('user', ['ou']),
    ...mapGetters('sites', ['getAllActiveSites', 'ouBySite']),
    ...mapGetters('requests', ['draft']),
    siteNameStyle() {
      return siteNameText(this.$vuetify.breakpoint)
    },
    fontWeightLightMd() {
      return this.$vuetify.breakpoint.mdAndUp ? 'font-weight-light' : ''
    },
    selected: {
      set: function(siteName) {
        this.saveDraft({ key: 'site', value: siteName })
        this.updateValidSection({ section: 'site', value: !!siteName })
      },
      get: function() {
        return this.draft.site
      }
    }
  },

  methods: {
    managedImg,
    ...mapActions('requests', ['saveDraft', 'updateValidSection'])
  },

  created() {
    const site = this.getAllActiveSites.find(
      s => this.ouBySite(s.id) === this.ou
    )
    this.selected = site.id
  }
}
</script>

<style>
.av-card-btn {
  text-transform: uppercase;
}
</style>
